import { createHttpAction } from '@securitize/ui-components';
import { GET_ISSUER_SETTINGS_NEXT } from './actionTypes';

export const getIssuerSettings = (onSuccess = () => undefined) => createHttpAction(
  GET_ISSUER_SETTINGS_NEXT,
  {},
  { onSuccess },
).action;
